import * as React from 'react';
import { connect } from 'react-redux';

import { NumberField } from '@cian/components';

import { IAppState, Dispatch } from '../../../../common/state';
import { changeOfferId } from '../../../state/advanced/offer_id';
import { InlineParam, Row } from '../markup';

interface IContactProps {
  offerId: number | undefined;
  onOfferIdChanged(offerId: number | void): void;
}

const offerId: React.StatelessComponent<IContactProps> = props => (
  <Row title="Номер объявления">
    <InlineParam>
      <NumberField
        disableFractional
        disableNegative
        value={props.offerId}
        onValueChange={value => props.onOfferIdChanged(value)}
      />
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    offerId: state.filters.jsonQuery.id && state.filters.jsonQuery.id.value,
  }),
  (dispatch: Dispatch) => ({
    onOfferIdChanged: (value: number | void) => {
      dispatch(changeOfferId(value));
    },
  }),
)(offerId);
